import { Link } from "react-router-dom";

function MyListings() {

  const token =
    localStorage.getItem("token");

  let currentUserId = null;

  if (token) {

    try {

      const payload =
        JSON.parse(
          atob(
            token.split(".")[1]
          )
        );

      currentUserId =
        payload.id;

    } catch (error) {

      console.error(
        "TOKEN ERROR:",
        error
      );

    }
  }


  const listings =
    JSON.parse(
      localStorage.getItem(
        "buySellListings"
      )
    ) || [];


  const myListings =
    listings.filter(
      (listing) =>
        String(
          listing.userId
        ) ===
        String(
          currentUserId
        )
    );


  return (

    <>

      <div className="my-listings-page">

        <div className="container">

          <div className="my-listings-header">

            <div>

              <span className="admin-label">
                MY ACCOUNT
              </span>

              <h1>
                Իմ հայտարարությունները
              </h1>

              <p>
                Այստեղ կարող ես տեսնել քո հայտարարությունների կարգավիճակը։
              </p>

            </div>


            <Link
              to="/"
              className="admin-back"
            >
              ← Կայք
            </Link>

          </div>


          {myListings.length === 0 ? (

            <div className="no-listings">

              <div className="empty-icon">
                📦
              </div>

              <h2>
                Հայտարարություններ չկան
              </h2>

              <p>
                Դու դեռ հայտարարություն չես տեղադրել։
              </p>

              <Link
                to="/create-listing"
                className="add-listing-button"
              >
                + Տեղադրել հայտարարություն
              </Link>

            </div>

          ) : (

            <div className="admin-listings-grid">

              {myListings.map(
                (listing) => (

                  <div
                    className="admin-listing-card"
                    key={listing.id}
                  >

                    <img
                      src={listing.image}
                      alt={listing.name}
                    />


                    <div className="admin-listing-content">

                      <span className="listing-category">
                        {listing.category}
                      </span>

                      <h2>
                        {listing.name}
                      </h2>

                      <h3>
                        {listing.price}
                      </h3>

                      <p>
                        {listing.description}
                      </p>


                      {listing.status ===
                        "pending" && (

                        <div className="listing-status pending-status">
                          🟠 Սպասվում է հաստատում
                        </div>

                      )}


                      {listing.status ===
                        "approved" && (

                        <div className="listing-status approved-status">
                          🟢 Հայտարարությունը հաստատված է
                        </div>

                      )}


                      {listing.status ===
                        "rejected" && (

                        <div className="listing-status rejected-status">

                          <strong>
                            🔴 Հայտարարությունը մերժվել է
                          </strong>

                          <p>
                            <strong>
                              Մերժման պատճառ՝
                            </strong>{" "}
                            {listing.rejectionReason}
                          </p>

                        </div>

                      )}

                    </div>

                  </div>

                )
              )}

            </div>

          )}

        </div>

      </div>

    </>
  );
}

export default MyListings;